import { useState } from 'react'
import { useSelectedCompany } from '../auth/CompanyContext'
import { useYear } from '../auth/YearContext'
import { subscribeYear } from '../lib/cloudStore'
import { generateSie4, downloadSie } from '../lib/sieExport'

export function ExportButton() {
  const { selected } = useSelectedCompany()
  const { year } = useYear()
  const [busy, setBusy] = useState(false)

  async function onClick() {
    setBusy(true)
    try {
      // Engångs-läsning av nuvarande state via onSnapshot + unsub
      const data = await new Promise<any>((resolve) => {
        const unsub = subscribeYear(selected.id, year, (d) => {
          unsub()
          resolve(d)
        })
      })

      if (!data || !data.months) {
        alert('Ingen data att exportera för ' + year)
        return
      }

      const sie = generateSie4({
        companyName: selected.name,
        orgNr: selected.orgNr,
        year,
        months: data.months,
      })

      const safeName = selected.name.replace(/[^\w\sÅÄÖåäö-]/g, '').replace(/\s+/g, '_')
      downloadSie(`${safeName}_${year}.se`, sie)
    } catch (e) {
      alert('Export-fel: ' + (e as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <button className="logout-btn" onClick={onClick} disabled={busy} title="Ladda ned SIE4-fil för valt bolag och år">
      {busy ? '…' : '📤 Export SIE'}
    </button>
  )
}
